import CartesianAxisBrainQuadrant from 'views/components/CartesianAxisBrainQuadrant'
import {
  BetesaBoldText,
  Container,
  AlertLevelText,
  ProfileIdeaInfoWrapper,
  ProfileIdealGraphWrapper,
  SkillsIdealProfileWrapper,
  BoldText,
  List,
  ListItem,
  WrapperInfoCompetences,
  BetesaEditText,
  DateWrapper,
} from './styles.styled'
import { InfoWrapper, NoBetesaContainer, Subtitle } from '../../styles.styled'
import { InfoText, Text, WrapperInfoItem } from '../GeneralInfo/styles.styled'
import { idealProfileBetesaSelector, idealProfileSkillsSelector, processDetailSelector } from '../../store'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { platformAdminRoutes } from 'router/routes'
import { FC, useEffect, useState } from 'react'
import { ALERT_LEVELS } from 'types/common'
import { userSelector } from 'ducks/user'
import { Row } from 'views/components/UI/Row'
import DatePicker from 'views/components/UI/Datepicker'
import dayjs from 'dayjs'
import { useNotification } from 'lib/context/notification.context'
import { Button } from 'views/components/UI/Buttons'
import ModalDateChange from './modal-date-change'
import test360GetProcessData from 'services/process/test360/test360GetProcessData'
import test360SaveFinalData from 'services/process/test360/test360SaveFinalData'
import sendReminderTestToUser from 'services/common/reports/postReminderTestToUser/postReminderTestToUser'
import TooltipComponent from 'views/components/Tooltip'

interface TestInfoAndIdealProfileProps {
  processId: number
  processName: string
}

interface ParticipantsProps {
  firs_name: string
  last_name: string
  email: string
  user_id: number
  role: string
  complete: boolean
}

interface Test360MembersProps {
  evaluatedUsers: number
  evaluators: number
  participants?: ParticipantsProps[]
}

interface Test360CompetencesProps {
  id: number
  name: string
  description: string
}

const TestInfoAndIdealProfile: FC<TestInfoAndIdealProfileProps> = ({ processId, processName }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { getWarning, getSuccess } = useNotification()
  const processDetail = useSelector(processDetailSelector)
  const userDetails = useSelector(userSelector)
  const { role } = useSelector((state: any) => state.auth)
  const hasRoleFamilyName = processDetail?.roleFamilyName !== null && processDetail?.roleFamilyName !== ''
  const idealProfileBetesa = useSelector(idealProfileBetesaSelector)
  const idealProfileSkills = useSelector(idealProfileSkillsSelector)
  const [test360Date, setTest360Date] = useState<string>('')
  const [originalTest360Date, setOriginalTest360Date] = useState<string>('')
  const [test360Competences, setTest360Competences] = useState<Test360CompetencesProps[]>([])
  const [test360Members, setTest360Members] = useState<Test360MembersProps>({ evaluatedUsers: 0, evaluators: 0 })
  const [showModalDateChange, setShowModalDateChange] = useState(false)
  const [updatedAt, setUpdatedAt] = useState<string>('')
  const formatIdealProfile = idealProfileBetesa?.map((item) => {
    return {
      quadrant: item.quadrant,
      min: item.min,
      max: item.max,
      priority: item.priority,
    }
  })

  useEffect(() => {
    if (processDetail?.has360Test) {
      test360GetProcessData(processId)
        .then((data) => {
          if (data?.final_date) {
            const formattedDate = dayjs(data?.final_date, ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD']).format(
              'DD-MM-YYYY'
            )
            const updateDate = dayjs(data?.updated_at).format('DD/MM/YYYY')

            setUpdatedAt(updateDate)
            setTest360Date(formattedDate)
            setOriginalTest360Date(formattedDate)
          }
          if (data?.competences) {
            setTest360Competences(data.competences)
          }
          if (data?.evaluators) {
            setTest360Members({
              participants: data.participants,
              evaluators: data.evaluators,
              evaluatedUsers: data.evaluated_users,
            })
          }
        })
        .catch((error) => {
          console.error('Error fetching process data:', error)
          getWarning('Error al obtener los datos del proceso')
        })
    }
  }, [getWarning, processDetail?.has360Test, processId])

  const handleTestNames = () => {
    const nameOfTests = []
    if (processDetail?.hasBetesaTest) nameOfTests.push('Betesa')
    if (processDetail?.hasCompetencesTest) nameOfTests.push(t('global.common.skillText'))
    if (processDetail?.has360Test) nameOfTests.push('360°')

    return nameOfTests.join(', ')
  }

  const alertLevelRange = idealProfileBetesa[0]?.alert_level_range

  const getAlertLevelRange = () => {
    for (let i = 0; i < alertLevelRange?.length - 1; i += 2) {
      const currentRange = alertLevelRange?.slice(i, i + 2)

      for (const [key, value] of Object.entries(ALERT_LEVELS)) {
        const isMatch = currentRange?.every((id) => value.includes(id))
        if (isMatch) {
          return key
        }
      }
    }

    return null
  }

  const alertLevel = getAlertLevelRange()

  const handleEditProfileBetesaButtonClick = () => {
    const betesaTestId = processDetail?.testids?.find((item) => item.category_id === 1).test_id
    navigate(platformAdminRoutes.EditIdealProfileBetesa, {
      state: { idealProfileBetesa, betesaTestId, processId, processName, alertLevel },
    })
  }

  const handleEditProfileSkillsButtonClick = () => {
    const skillsTestId = processDetail?.testids?.find((item) => item.category_id === 2)?.test_id
    navigate(platformAdminRoutes.EditIdealProfileSkills, {
      state: {
        idealProfileSkills,
        skillsTestId,
        processId,
        processName,
        levelName: processDetail?.levelName,
      },
    })
  }

  const validateIdealProfileEdit = () => {
    if (processDetail?.userId === userDetails?.userId) {
      return true
    }
    if (role === 'super_platform_admin') {
      return true
    }
    return false
  }

  const handleChangeTest360Date = (date: string) => {
    setTest360Date(date)
  }

  const isDateChanged = () => {
    return test360Date !== originalTest360Date && test360Date !== ''
  }

  const handleSaveTest360Date = () => {
    if (!test360Date) {
      getWarning('Por favor, seleccione una fecha válida')
      return
    }
    test360SaveFinalData(processId, test360Date)
      .then((response) => {
        if (response?.message === 'Success') {
          setUpdatedAt(dayjs(response.data.updated_at).format('DD/MM/YYYY'))
          setOriginalTest360Date(test360Date)
          getSuccess('Fecha de cierre actualizada correctamente')
        } else {
          getWarning('Error al actualizar la fecha de cierre')
        }
      })
      .catch((error) => {
        console.error('Error saving test 360 final date:', error)
        getWarning('Error al guardar la fecha de cierre del test 360°')
      })
    setShowModalDateChange(true)
  }

  const handleSendNotification = () => {
    setShowModalDateChange(false)

    const incompleteParticipants = test360Members.participants?.filter((participant) => !participant.complete) || []

    if (incompleteParticipants.length === 0) {
      getWarning('No hay participantes pendientes de completar la evaluación')
      return
    }

    const emails = incompleteParticipants.map((participant) => ({ email: participant.email }))

    sendReminderTestToUser({ emails }, processId)
      .then((response) => {
        if (response?.status === 'OK') {
          const uniqueEmails = Array.from(new Set(emails.map((email) => email.email)))
          getSuccess(`Notificación enviada correctamente a ${uniqueEmails.length} participante(s)`)
        } else {
          getWarning('Error al enviar las notificaciones')
        }
      })
      .catch((error) => {
        console.error('Error sending reminder:', error)
        getWarning('Error al enviar las notificaciones')
      })
  }

  return (
    <Container>
      <Subtitle>Información de pruebas y perfiles ideales</Subtitle>
      <InfoWrapper>
        <WrapperInfoItem>
          <Text>Pruebas aplicadas:</Text>
          <Text>Fue creada con:</Text>
        </WrapperInfoItem>
        <WrapperInfoItem>
          <InfoText>{handleTestNames()}</InfoText>
          {hasRoleFamilyName ? (
            <InfoText>{processDetail?.roleFamilyName}</InfoText>
          ) : (
            <InfoText>Configuración desde cero</InfoText>
          )}
        </WrapperInfoItem>
      </InfoWrapper>

      {processDetail?.hasBetesaTest && idealProfileBetesa?.length > 0 ? (
        <>
          <InfoWrapper>
            <WrapperInfoItem>
              <BetesaBoldText>Perfil ideal Betesa:</BetesaBoldText>
            </WrapperInfoItem>
            <BetesaEditText
              valid={validateIdealProfileEdit()}
              onClick={validateIdealProfileEdit() ? handleEditProfileBetesaButtonClick : () => {}}
            >
              Editar perfil ideal
            </BetesaEditText>
          </InfoWrapper>
          <ProfileIdeaInfoWrapper>
            <AlertLevelText>Nivel de alerta: {alertLevel}</AlertLevelText>
            <ProfileIdealGraphWrapper>
              <CartesianAxisBrainQuadrant
                data={formatIdealProfile}
                isReport={false}
                style={{
                  height: '80%',
                  width: '100%',
                }}
              />
            </ProfileIdealGraphWrapper>
          </ProfileIdeaInfoWrapper>
        </>
      ) : processDetail?.hasBetesaTest ? (
        <NoBetesaContainer>
          <InfoWrapper>
            <WrapperInfoItem>
              <BoldText>Perfil ideal Betesa:</BoldText>
            </WrapperInfoItem>
          </InfoWrapper>
          <InfoText>No se configuró perfil ideal para este proceso</InfoText>
        </NoBetesaContainer>
      ) : null}

      {processDetail?.hasCompetencesTest && idealProfileSkills.length > 0 ? (
        <>
          <InfoWrapper>
            <WrapperInfoItem>
              <BoldText>Perfil ideal {t('global.common.skillText')}:</BoldText>
            </WrapperInfoItem>
            <BetesaEditText
              valid={validateIdealProfileEdit()}
              onClick={validateIdealProfileEdit() ? handleEditProfileSkillsButtonClick : () => {}}
            >
              Editar perfil ideal
            </BetesaEditText>
          </InfoWrapper>
          <SkillsIdealProfileWrapper>
            <WrapperInfoCompetences>
              <List>
                {idealProfileSkills.map((item) => (
                  <ListItem key={item.skillName}>
                    {item.skillName}
                    {item.skillWeight ? `: Superior a ${item.skillWeight}` : null}
                  </ListItem>
                ))}
              </List>
            </WrapperInfoCompetences>
          </SkillsIdealProfileWrapper>
        </>
      ) : processDetail?.hasCompetencesTest ? (
        <NoBetesaContainer>
          <InfoWrapper>
            <WrapperInfoItem>
              <BoldText>Perfil ideal {t('global.common.skillText')}:</BoldText>
            </WrapperInfoItem>
          </InfoWrapper>
          <InfoText>No se configuró perfil ideal para este proceso</InfoText>
        </NoBetesaContainer>
      ) : null}
      {processDetail?.has360Test ? (
        <>
          <InfoWrapper style={{ marginTop: '20px' }}>
            <WrapperInfoItem>
              <BoldText>Evaluación 360°:</BoldText>
            </WrapperInfoItem>
          </InfoWrapper>
          <InfoWrapper>
            <Row justifyContent="flex-start" alignItems="center" gap="100px">
              <Row flexDirection="column" gap="10px" width="fit-content">
                <BoldText style={{ fontWeight: 500 }}>Fecha de cierre</BoldText>
                <InfoText>Editado: {updatedAt}</InfoText>
              </Row>
              <DateWrapper>
                <DatePicker
                  label="Seleccione la fecha de cierre"
                  minDate={new Date()}
                  format="DD/MM/YYYY"
                  iconColor="#2D749C"
                  value={test360Date ? dayjs(test360Date, ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD']) : undefined}
                  onChange={(e) => {
                    const currentDate = new Date()
                    const today = dayjs(currentDate).startOf('day')
                    const selectedDate = dayjs(e).startOf('day')

                    if (selectedDate.isBefore(today)) {
                      getWarning('No se puede seleccionar una fecha anterior a la actual')
                      return
                    }
                    const formattedDate = dayjs(e).format('DD-MM-YYYY')
                    if (!dayjs(formattedDate, 'DD-MM-YYYY', true).isValid()) {
                      return
                    } else {
                      handleChangeTest360Date(formattedDate)
                    }
                  }}
                />
                <TooltipComponent
                  tooltipText="La evaluación 360° se deshabilitará para quienes no la hayan respondido antes de la fecha que selecciones. Podrás editar esta fecha desde el dashboard de administrador."
                  placement="top"
                  iconColor="#2D749C"
                  backgroundColor="#2D749C"
                />
              </DateWrapper>
              <Button onClick={handleSaveTest360Date} disabled={!isDateChanged()}>
                Guardar
              </Button>
            </Row>
          </InfoWrapper>
          <InfoWrapper style={{ marginTop: '20px' }}>
            <WrapperInfoItem>
              <BoldText>Lista de competencias:</BoldText>
            </WrapperInfoItem>
            <WrapperInfoCompetences>
              <List>
                {test360Competences.map((item, index: number) => (
                  <ListItem key={`${item.name}-${index}`}>{item.name}</ListItem>
                ))}
              </List>
            </WrapperInfoCompetences>
          </InfoWrapper>
          <InfoWrapper style={{ marginTop: '20px' }}>
            <WrapperInfoItem>
              <BoldText>Número de evaluadores:</BoldText>
            </WrapperInfoItem>
            <WrapperInfoCompetences>
              <InfoText>{test360Members.evaluators} evaluadores</InfoText>
            </WrapperInfoCompetences>
          </InfoWrapper>
          <InfoWrapper style={{ marginTop: '20px' }}>
            <WrapperInfoItem>
              <BoldText>Número de evaluados:</BoldText>
            </WrapperInfoItem>
            <WrapperInfoCompetences>
              <InfoText>{test360Members.evaluatedUsers} evaluados</InfoText>
            </WrapperInfoCompetences>
          </InfoWrapper>
          <ModalDateChange
            showModal={showModalDateChange}
            handleClose={() => setShowModalDateChange(false)}
            handleSendNotification={handleSendNotification}
          />
        </>
      ) : null}
    </Container>
  )
}

export default TestInfoAndIdealProfile
